import React from "react";
import FeatureCard from "pages/browse-apps/component/feature-card";
import { useApps } from "hooks/useApps";
import NoData from "components/noData/noData";
import AppFilters from "pages/browse-apps/component/app-filters";
import { useRecoilState, useResetRecoilState } from "recoil";
import { AppsFilterAtom } from "pages/browse-apps/browse-apps.service";
import SearchInput from "components/search-input/search-input";
import { useTranslation } from "react-i18next";
import { useMount } from "react-use";
import { Spinner } from "react-bootstrap";
import ErrorMessage from "components/error/error";

const BrowseAppsPage = () => {
	const { t } = useTranslation("browse-apps");
	const [{ search }, setFilters] = useRecoilState(AppsFilterAtom);
	const { appsList, addOnsList, isLoading, isFetching, isSuccess,isError } = useApps();
	const resetList = useResetRecoilState(AppsFilterAtom);

	useMount(() => {
		resetList();
	});

	return (
		<div className="wishlist browserApps">
			<div className="header">
				<h1 className="title">{t("mainTitle")}</h1>
				<div className="page-action">
					<SearchInput
						value={search}
						onChange={(search) =>
							setFilters((f) => ({ ...f, search }))
						}
					/>
				</div>
			</div>
			<hr className="hr" />
			<div className="row">
				<div className="col-xl-2 col-lg-3">
					<AppFilters />
				</div>
				<div className="col-xl-10 col-lg-9">
					<div className="row">
						<div className="col-12">
							<h1 className="title">{t("applications")}</h1>
						</div>
						{isError && <ErrorMessage />}
						{(isLoading) && (
							<div className="my-center">
								<Spinner animation="grow" variant="primary" />
							</div>
						)}
						{isSuccess && appsList.length > 0 ? (
							appsList.map((application) => (
								<div
									className="col-xl-3 col-lg-4 col-md-4 col-sm-6"
									key={application.id}
								>
									<FeatureCard
										application
										id={application.id}
										isWishListed={application.isWishListed}
										title={application.title}
										Label={application.label}
										logo={application.image.fullPath}
										info={application.featuredTag}
										content={application.description}
										price={application.price}
										rate={application.rate}
										count={application.numberOfRates}
									/>
								</div>
							))
						) : (isSuccess || appsList.length < 0) &&	<NoData />}

						<div className="col-12">
							<h1 className="title">{t("addons")}</h1>
						</div>
						{isError && <ErrorMessage />}
						{(isLoading) && (
							<div className="my-center">
								<Spinner animation="grow" variant="primary" />
							</div>
						)}
						{isSuccess && addOnsList.length > 0 ? (
							addOnsList.map((addOn) => (
								<div
									className="col-xl-3 col-lg-4 col-md-4 col-sm-6"
									key={addOn.id}
								>
									<FeatureCard
										id={addOn.id}
										isWishListed={addOn.isWishListed}
										title={addOn.title}
										Label={addOn.label}
										logo={addOn.image.fullPath}
										info={addOn.featuredTag}
										content={addOn.description}
										price={addOn.price}
										rate={addOn.rate}
										count={addOn.numberOfRates}
									/>
								</div>
							))
						) : ( isSuccess || addOnsList.length < 0) && <NoData />}
					</div>
				</div>
			</div>
		</div>
	);
};

export default BrowseAppsPage;
